import { createTemplateFactory } from "@ember/template-factory";
export default createTemplateFactory(
/*
  {{#if this.canAdminGroup}}
  <div class="control-group">
    <label class="control-label">
      {{i18n "admin.groups.manage.interaction.visibility"}}
    </label>
    <label>
      {{i18n "admin.groups.manage.interaction.visibility_levels.title"}}
    </label>

    <ComboBox
      @name="alias"
      @valueProperty="value"
      @value={{this.model.visibility_level}}
      @content={{this.visibilityLevelOptions}}
      @onChange={{fn (mut this.model.visibility_level)}}
      @options={{hash castInteger=true}}
      class="groups-form-visibility-level"
    />

    <div class="control-instructions">
      {{i18n "admin.groups.manage.interaction.visibility_levels.description"}}
    </div>
  </div>

  <div class="control-group">
    <label>
      {{i18n "admin.groups.manage.interaction.members_visibility_levels.title"}}
    </label>

    <ComboBox
      @name="alias"
      @valueProperty="value"
      @value={{this.membersVisibilityLevel}}
      @content={{this.visibilityLevelOptions}}
      @onChange={{fn (mut this.model.members_visibility_level)}}
      class="groups-form-members-visibility-level"
    />

    {{#if this.membersVisibilityPrivate}}
      <div class="control-instructions">
        {{i18n
          "admin.groups.manage.interaction.members_visibility_levels.description"
        }}
      </div>
    {{/if}}
  </div>
{{/if}}

<div class="control-group">
  <label class="control-label">
    {{i18n "groups.manage.interaction.posting"}}
  </label>
  <label for="alias">{{i18n "groups.alias_levels.mentionable"}}</label>

  <ComboBox
    @name="alias"
    @valueProperty="value"
    @value={{this.mentionableLevel}}
    @content={{this.aliasLevelOptions}}
    @onChange={{fn (mut this.model.mentionable_level)}}
    class="groups-form-mentionable-level"
  />
</div>

<div class="control-group">
  <label for="alias">{{i18n "groups.alias_levels.messageable"}}</label>

  <ComboBox
    @name="alias"
    @valueProperty="value"
    @value={{this.messageableLevel}}
    @content={{this.aliasLevelOptions}}
    @onChange={{fn (mut this.model.messageable_level)}}
    class="groups-form-messageable-level"
  />
</div>

{{#if this.canAdminGroup}}
  <div class="control-group">
    <label>
      <Input
        @type="checkbox"
        @checked={{this.model.publish_read_state}}
        class="groups-form-publish-read-state"
      />

      {{i18n "admin.groups.manage.interaction.publish_read_state"}}
    </label>
  </div>
{{/if}}

{{#if this.showEmailSettings}}
  <div class="control-group">
    <label class="control-label">
      {{i18n "admin.groups.manage.interaction.email"}}
    </label>
    <label for="incoming_email">
      {{i18n "admin.groups.manage.interaction.incoming_email"}}
    </label>

    <TextField
      @name="incoming_email"
      @value={{this.model.incoming_email}}
      @placeholderKey="admin.groups.manage.interaction.incoming_email_placeholder"
      class="input-xxlarge groups-form-incoming-email"
    />

    <DTooltip
      @icon="info-circle"
      @content={{i18n "admin.groups.manage.interaction.incoming_email_tooltip"}}
    />

    <span>
      <PluginOutlet
        @name="group-email-in"
        @connectorTagName="div"
        @outletArgs={{hash model=this.model}}
      />
    </span>
  </div>
{{/if}}

<label class="control-label">
  {{i18n "groups.manage.interaction.notification"}}
</label>

<div class="control-group">
  <label>{{i18n "groups.notification_level"}}</label>

  <NotificationsButton
    @value={{this.defaultNotificationLevel}}
    @options={{hash i18nPrefix="groups.notifications"}}
    @onChange={{fn (mut this.model.default_notification_level)}}
    class="groups-form-default-notification-level"
  />
</div>

<span>
  <PluginOutlet
    @name="groups-interaction-custom-options"
    @connectorTagName="div"
    @outletArgs={{hash model=this.model}}
  />
</span>
*/
{
  "id": "2S6RGLad",
  "block": "[[[41,[30,0,[\"canAdminGroup\"]],[[[1,\"  \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n    \"],[10,\"label\"],[14,0,\"control-label\"],[12],[1,\"\\n      \"],[1,[28,[35,1],[\"admin.groups.manage.interaction.visibility\"],null]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,\"label\"],[12],[1,\"\\n      \"],[1,[28,[35,1],[\"admin.groups.manage.interaction.visibility_levels.title\"],null]],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[8,[39,2],[[24,0,\"groups-form-visibility-level\"]],[[\"@name\",\"@valueProperty\",\"@value\",\"@content\",\"@onChange\",\"@options\"],[\"alias\",\"value\",[30,0,[\"model\",\"visibility_level\"]],[30,0,[\"visibilityLevelOptions\"]],[28,[37,3],[[28,[37,4],[[30,0,[\"model\",\"visibility_level\"]]],null]],null],[28,[37,5],null,[[\"castInteger\"],[true]]]]],null],[1,\"\\n\\n    \"],[10,0],[14,0,\"control-instructions\"],[12],[1,\"\\n      \"],[1,[28,[35,1],[\"admin.groups.manage.interaction.visibility_levels.description\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n    \"],[10,\"label\"],[12],[1,\"\\n      \"],[1,[28,[35,1],[\"admin.groups.manage.interaction.members_visibility_levels.title\"],null]],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[8,[39,2],[[24,0,\"groups-form-members-visibility-level\"]],[[\"@name\",\"@valueProperty\",\"@value\",\"@content\",\"@onChange\"],[\"alias\",\"value\",[30,0,[\"membersVisibilityLevel\"]],[30,0,[\"visibilityLevelOptions\"]],[28,[37,3],[[28,[37,4],[[30,0,[\"model\",\"members_visibility_level\"]]],null]],null]]],null],[1,\"\\n\\n\"],[41,[30,0,[\"membersVisibilityPrivate\"]],[[[1,\"      \"],[10,0],[14,0,\"control-instructions\"],[12],[1,\"\\n        \"],[1,[28,[35,1],[\"admin.groups.manage.interaction.members_visibility_levels.description\"],null]],[1,\"\\n      \"],[13],[1,\"\\n\"]],[]],null],[1,\"  \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n  \"],[10,\"label\"],[14,0,\"control-label\"],[12],[1,\"\\n    \"],[1,[28,[35,1],[\"groups.manage.interaction.posting\"],null]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,\"label\"],[14,\"for\",\"alias\"],[12],[1,[28,[35,1],[\"groups.alias_levels.mentionable\"],null]],[13],[1,\"\\n\\n  \"],[8,[39,2],[[24,0,\"groups-form-mentionable-level\"]],[[\"@name\",\"@valueProperty\",\"@value\",\"@content\",\"@onChange\"],[\"alias\",\"value\",[30,0,[\"mentionableLevel\"]],[30,0,[\"aliasLevelOptions\"]],[28,[37,3],[[28,[37,4],[[30,0,[\"model\",\"mentionable_level\"]]],null]],null]]],null],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n  \"],[10,\"label\"],[14,\"for\",\"alias\"],[12],[1,[28,[35,1],[\"groups.alias_levels.messageable\"],null]],[13],[1,\"\\n\\n  \"],[8,[39,2],[[24,0,\"groups-form-messageable-level\"]],[[\"@name\",\"@valueProperty\",\"@value\",\"@content\",\"@onChange\"],[\"alias\",\"value\",[30,0,[\"messageableLevel\"]],[30,0,[\"aliasLevelOptions\"]],[28,[37,3],[[28,[37,4],[[30,0,[\"model\",\"messageable_level\"]]],null]],null]]],null],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"canAdminGroup\"]],[[[1,\"  \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n    \"],[10,\"label\"],[12],[1,\"\\n      \"],[8,[39,6],[[24,0,\"groups-form-publish-read-state\"]],[[\"@type\",\"@checked\"],[\"checkbox\",[30,0,[\"model\",\"publish_read_state\"]]]],null],[1,\"\\n\\n      \"],[1,[28,[35,1],[\"admin.groups.manage.interaction.publish_read_state\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[30,0,[\"showEmailSettings\"]],[[[1,\"  \"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n    \"],[10,\"label\"],[14,0,\"control-label\"],[12],[1,\"\\n      \"],[1,[28,[35,1],[\"admin.groups.manage.interaction.email\"],null]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,\"label\"],[14,\"for\",\"incoming_email\"],[12],[1,\"\\n      \"],[1,[28,[35,1],[\"admin.groups.manage.interaction.incoming_email\"],null]],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[8,[39,7],[[24,0,\"input-xxlarge groups-form-incoming-email\"]],[[\"@name\",\"@value\",\"@placeholderKey\"],[\"incoming_email\",[30,0,[\"model\",\"incoming_email\"]],\"admin.groups.manage.interaction.incoming_email_placeholder\"]],null],[1,\"\\n\\n    \"],[8,[39,8],null,[[\"@icon\",\"@content\"],[\"info-circle\",[28,[37,1],[\"admin.groups.manage.interaction.incoming_email_tooltip\"],null]]],null],[1,\"\\n\\n    \"],[10,1],[12],[1,\"\\n      \"],[8,[39,9],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"group-email-in\",\"div\",[28,[37,5],null,[[\"model\"],[[30,0,[\"model\"]]]]]]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[10,\"label\"],[14,0,\"control-label\"],[12],[1,\"\\n  \"],[1,[28,[35,1],[\"groups.manage.interaction.notification\"],null]],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,0],[14,0,\"control-group\"],[12],[1,\"\\n  \"],[10,\"label\"],[12],[1,[28,[35,1],[\"groups.notification_level\"],null]],[13],[1,\"\\n\\n  \"],[8,[39,10],[[24,0,\"groups-form-default-notification-level\"]],[[\"@value\",\"@options\",\"@onChange\"],[[30,0,[\"defaultNotificationLevel\"]],[28,[37,5],null,[[\"i18nPrefix\"],[\"groups.notifications\"]]],[28,[37,3],[[28,[37,4],[[30,0,[\"model\",\"default_notification_level\"]]],null]],null]]],null],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,1],[12],[1,\"\\n  \"],[8,[39,9],null,[[\"@name\",\"@connectorTagName\",\"@outletArgs\"],[\"groups-interaction-custom-options\",\"div\",[28,[37,5],null,[[\"model\"],[[30,0,[\"model\"]]]]]]],null],[1,\"\\n\"],[13]],[],false,[\"if\",\"i18n\",\"combo-box\",\"fn\",\"mut\",\"hash\",\"input\",\"text-field\",\"d-tooltip\",\"plugin-outlet\",\"notifications-button\"]]",
  "moduleName": "discourse/components/groups-form-interaction-fields.hbs",
  "isStrictMode": false
});